import { FC, useEffect } from 'react';
import { set as setAPICookie } from '../../../cookie/AffiliateAPICookie';
import { set as setCookie } from '../../../cookie/AffiliateCookie';
import { useNavigate, useParams } from 'react-router-dom';
import fetchWebApi from '../../../api/fetchWebApi';
import Loading from '../../components/LoanApplicationProcessLayout/Loading/Loading';

const AffiliateScene: FC = () => {
  const navigate = useNavigate();
  const { provider } = useParams();

  useEffect(() => {
    const fetchAffiliateSetCookie = async () => {
      const searchParams = new URLSearchParams(location.search);

      const token = searchParams.get('tkn') || '';
      const subid = searchParams.get('subid') || '';

      const queryParams = new URLSearchParams({ token, subid });
      const url = `/affiliate/data/${provider}`;

      try {
        const affiliate = await fetchWebApi(url, queryParams, {
          method: 'get',
        });

        setCookie({
          affiliatePartner: affiliate.partner,
          affiliateProvider: provider,
          affiliateToken: token,
          affiliateRedirectUrl: affiliate.redirectUrl,
        });

        setAPICookie({
          vvs_utmcpg: affiliate.partner,
          vvs_utmmed: 'affiliate',
          vvs_utmsrc: provider,
        });

        if (affiliate?.redirectUrl) {
          window.location.assign(`/${affiliate.redirectUrl}`);
          return;
        }

        navigate('/');
      } catch (e) {
        navigate('/');
      }
    };

    fetchAffiliateSetCookie();
  }, []);

  return <Loading />;
};

export default AffiliateScene;
